import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import { CostCenters } from "./cost-centers";
import { InvoiceDefaultApprovers } from "./invoice-default-approvers";
import { OrganizationBusinessHours } from "./organization-business-hours";
import { OrganizationMailboxes } from "./organization-mailboxes";

export function OrganizationSettingsInvoices() {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tabs
			panelKey="organization-invoices-tabs"
			groups={[
				{
					name: "incoming-invoices",
					panels: [
						{
							label: t("incoming_invoices.mailboxes"),
							cyId: "incoming-invoice-mailboxes-tab",
							errors: [],
							panel: () => <OrganizationMailboxes purpose="incoming-invoices" />,
						},
						{
							label: t("incoming_invoices.default_approvers"),
							cyId: "incoming-invoice-default-approvers-tab",
							errors: [],
							panel: () => <InvoiceDefaultApprovers />,
						},
						{
							label: t("organization.business_hours"),
							cyId: "organization-business-hours-tab",
							errors: [],
							panel: () => <OrganizationBusinessHours />,
						},
						{
							label: t("cost_centers.cost_centers"),
							cyId: "cost-centers-tab",
							errors: [],
							panel: () => <CostCenters />,
						},
					],
				},
			]}
		/>
	);
}
